import { render, staticRenderFns } from "./AudioTranslate.vue?vue&type=template&id=32ed532e&scoped=true"
import script from "./AudioTranslate.vue?vue&type=script&lang=js"
export * from "./AudioTranslate.vue?vue&type=script&lang=js"
import style0 from "./AudioTranslate.vue?vue&type=style&index=0&id=32ed532e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ed532e",
  null
  
)

export default component.exports